<h1 mat-dialog-title>Confirm your details</h1>
<div mat-dialog-content>
  <p>Please check all your details are correct</p>
</div>
<div mat-dialog-actions align="end">
  <button data-testid="cancel-button" mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button data-testid="confirm-button" mat-raised-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>Confirm</button>
</div>